import AccountStatementsSelectedMonthScreen from 'features/statementsAndForms/screens/AccountStatements/AccountStatementsSelectedMonth';
import React from 'react';

export default function AccountStatementsSelectedMonthPage() {
  return <AccountStatementsSelectedMonthScreen />;
}
